const state = {
  pazymaID: null,
  pazymaTipas: '',
  pazymaBusena: '',
  pazymaBusenaTolimesne: '',
  pazymaReadonly: false,
  pazymaOwner: false,
  pazymaSignStatus: false,
  pazymaSistema: '',
  pazymaTeikejasRole: '',
  savitarnaRedirect:
    JSON.parse(sessionStorage.getItem('savitarnaRedirect')) || null,
}

// getters
const getters = {
  pazymaID: state => state.pazymaID,
  pazymaTipas: state => state.pazymaTipas,
  pazymaBusena: state => state.pazymaBusena,
  pazymaBusenaTolimesne: state => state.pazymaBusenaTolimesne,
  pazymaReadonly: state => state.pazymaReadonly,
  pazymaOwner: state => state.pazymaOwner,
  pazymaSignStatus: state => state.pazymaSignStatus,
  pazymaSistema: state => state.pazymaSistema,
  pazymaTeikejasRole: state => state.pazymaTeikejasRole,
  savitarnaRedirect: state => state.savitarnaRedirect,
}

// actions
const actions = {
  pazymaID({ commit }, payload) {
    commit('pazymaID', payload)
    sessionStorage.setItem(
      'pazymaID',
      parseInt(payload) ? JSON.stringify(payload) : null
    )
  },
  pazymaTipas({ commit }, payload) {
    commit('pazymaTipas', payload)
    sessionStorage.setItem('pazymaTipas', JSON.stringify(payload))
  },
  pazymaBusena({ commit }, payload) {
    commit('pazymaBusena', payload)
    sessionStorage.setItem('pazymaBusena', JSON.stringify(payload))
  },
  pazymaBusenaTolimesne({ commit }, payload) {
    commit('pazymaBusenaTolimesne', payload)
    sessionStorage.setItem('pazymaBusenaTolimesne', JSON.stringify(payload))
  },
  pazymaReadonly({ commit }, payload) {
    commit('pazymaReadonly', payload)
    sessionStorage.setItem('pazymaReadonly', JSON.stringify(payload))
  },
  pazymaOwner({ commit }, payload) {
    commit('pazymaOwner', payload)
    sessionStorage.setItem('pazymaOwner', JSON.stringify(payload))
  },
  pazymaSignStatus({ commit }, payload) {
    commit('pazymaSignStatus', payload)
    sessionStorage.setItem('pazymaSignStatus', JSON.stringify(payload))
  },
  pazymaSistema({ commit }, payload) {
    commit('pazymaSistema', payload)
    sessionStorage.setItem('pazymaSistema', JSON.stringify(payload))
  },
  pazymaTeikejasRole({ commit }, payload) {
    commit('pazymaTeikejasRole', payload)
    sessionStorage.setItem('pazymaTeikejasRole', JSON.stringify(payload))
  },
  savitarnaRedirect({ commit }, payload) {
    commit('savitarnaRedirect', payload)
    sessionStorage.setItem('savitarnaRedirect', JSON.stringify(payload))
  },
}

// mutations
const mutations = {
  pazymaID(state, data) {
    state.pazymaID = data
  },
  pazymaTipas(state, data) {
    state.pazymaTipas = data
  },
  pazymaBusena(state, data) {
    state.pazymaBusena = data
  },
  pazymaBusenaTolimesne(state, data) {
    state.pazymaBusenaTolimesne = data
  },
  pazymaReadonly(state, data) {
    state.pazymaReadonly = data
  },
  pazymaOwner(state, data) {
    state.pazymaOwner = data
  },
  pazymaSignStatus(state, data) {
    state.pazymaSignStatus = data
  },
  pazymaSistema(state, data) {
    state.pazymaSistema = data
  },
  pazymaTeikejasRole(state, data) {
    state.pazymaTeikejasRole = data
  },
  savitarnaRedirect(state, data) {
    state.savitarnaRedirect = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
